// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/node_modules/core-js/modules/_to-object.js
// module id = ../../../../core-js/modules/_to-object.js
// module chunks = polyfills